import { render, staticRenderFns } from "./MediaGalleryItem.vue?vue&type=template&id=0a6b0bba&scoped=true&"
import script from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaGalleryItem.vue?vue&type=style&index=0&id=0a6b0bba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b0bba",
  null
  
)

export default component.exports